import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';
import CircularProgress from '@material-ui/core/CircularProgress';

//COMPONENTS
import { Row, Column, IBox, Content, Icon, Select, SelectCentroCusto } from '../inspinia'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { SMS } from '../../store/tipoListaEmail';

class NovaSms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            campoCampanha: { id: '', nome: '' },
            disabledSelectCampanhaAdesao: true,
            disabledNomeCampanhaAdesao: true,
            locationUrl: this.props.location.pathname,
            novaCampanha: '',
            idCampanha: '',
            urlGeradoCampanhaAdesao: '',
            selectedContactId: null,
            form: this.formInitialState(),

            //Utilizado para recuperar as informações da campanha 
            emailUsuario: this.props.auth.user.email,
            usuario: {},
            auth: this.props.auth,


            list: {
                currentPage: 0,
                pageCount: 0,
                pageSize: 0,
                rowCount: 0,
                results: undefined
            },
            filteredList: {
                currentPage: 0,
                pageCount: 0,
                pageSize: 0,
                rowCount: 0,
                result: undefined
            },
            comboEmpresa: {
                results: undefined
            },
            comboCentroCusto: {
                results: undefined
            },
            comboCampoCampanhaAdesao: {
                results: undefined
            },

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },

        }

        this.handleChange = this.handleChange.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSaveAndGo = this.handleSaveAndGo.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleBlur = this.handleBlur.bind(this);

        this.state.usuario['email'] = this.state.emailUsuario;

    }

    handleSelect = (id) => {
        this.setState({ selectedContactId: id });
    };

    formInitialState() {

        return {
            nome: '',
            assunto: "",
            empresa: { id: 0 },
            remetente: { id: "" },
            emailUsuario: '',
            centroCusto: { id: 0 },
            listaContato: { id: 0 },
            campanhaAdesaoPersonalizada: false,
            campoCampanhaAdesao: { id: 0 },
            nomeCampanhaAdesao: '',
            urlGeradoCampanhaAdesao: '',
            campanhaAdesao: { id: 0 },
            tipoCampanha: SMS
        }
    }


    componentDidMount() {
        this.SelecionarTipoOperacao();
        this.RecuperarIdCampanhaEditar();
        this.LoadComboEmpresa();
        this.LoadListaContato();
        this.LoadComboCampoCampanhaAdesao();

        const { listaContato } = this.state.form;
        if (listaContato && listaContato.id > 0) {
            this.LoadComboCampoCampanhaAdesao(listaContato.id); 
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.form.listaContato.id !== this.state.form.listaContato.id) {
            const { listaContato } = this.state.form;
            if (listaContato && listaContato.id > 0) {
                this.LoadComboCampoCampanhaAdesao(listaContato.id);
            }
        }
    }


    handleSearch(e) {
        let currentList = this.state.filteredList;
        let newList = {};

        if (e.target.value !== "" && e.target.value !== null) {

            currentList = this.state.list;
            newList.results = currentList.results.filter(item => {
                const lc = item.nome.toLowerCase();
                const filter = e.target.value.toLowerCase();
                return lc.includes(filter);
            });
        } else {
            newList = currentList;
        }

        this.setState({
            list: newList
        });
    }

    handleChange(e) {
        const valor = e.target.value;
        let nome = e.target.name;
        let form = this.state.form;

        if (nome === "empresa") {
            this.setState(prevState => {
                const inputs = { ...prevState.form };

                inputs.empresa.id = parseInt(valor);
                this.LoadComboCentroCusto(inputs.empresa.id);
                return { inputs }
            });
        } else if (nome === "centroCusto") {

            this.setState(prevState => {
                const inputs = { ...prevState.form };

                inputs.centroCusto.id = parseInt(valor);
                return { inputs }
            });
        } else if (nome === "campanhaAdesao") {
            let checked = e.target.checked;
            this.setState({
                ...this.state,
                disabledSelectCampanhaAdesao: !checked,
                disabledNomeCampanhaAdesao: !checked,
                form: { ...form, campanhaAdesaoPersonalizada: checked }
            });
        } else if (nome === "campoCampanhaAdesao") {
            const id = isNaN(valor) ? 0 : valor;
            const op = (this.state.comboCampoCampanhaAdesao.results || [])
                    .find(item => item.value === id);

            const nome = op ? op.label : "";

            this.setState(prev => ({
                form: {
                    ...prev.form,
                    campoCampanhaAdesao: { id }
                },
                campoCampanha: { id, nome }
            }));
        } else {
            this.setState({ form: { ...form, [e.target.name]: e.target.value } });

        }
    }


    handleCheckChange(e) {
        let checked = e.target.checked;
        let valor = e.target.value;
        let nome = e.target.name;
        let form = this.state;

        if (nome === "contatoId") {

            this.setState(prevState => {
                const inputs = { ...prevState.form };
                inputs.listaContato.id = parseInt(valor);
                return { inputs }
            });

            this.LoadComboTagPorLista(valor, true);

            this.LoadComboCampoCampanhaAdesao(valor);
        } else {
            this.setState({ disabledSelect: !checked });
            this.setState({ form: { ...form, [e.target.name]: e.target.checked } });

        }

    }

    handleBlur(e) {
        if (e.target.value !== "") {
            const self = this;

            let value = e.target.value;
            value = value.replaceAll('/', '-');
            self.setState({ ...self.state, form: { ...self.state.form, nomeCampanhaAdesao: value } });
            const url = `${c.API_BASE_URL}/campanha/adesao/campanha/slug`;
            const options = this.state.optionsGet;

            callApi(url, options, function (response) {
                self.setState({ ...self.state, urlGeradoCampanhaAdesao: response.url });
            });
        } else {
            this.setState({ ...this.state, urlGeradoCampanhaAdesao: "" });
        }
    }


    LoadComboTagPorLista(value, acionarPesquisaPorId) {
        let self = this;

        if (acionarPesquisaPorId != undefined) {

            let valor = value ? value : self.props.campanha.campanha.form.listaContato.id;

            const url = `${c.API_BASE_URL}/tagsOfContactList/${valor}`;
            const options = self.state.optionsGet;

            self.setState({ ...self.state, loading: true })

            callApi(url, options, function (response) {
                self.setState({ ...self.state, loading: false, comboTag: response });
            });
        }

    }

    ValidarCampos(form) {
        return !form.nome || !form.assunto
            || (form.empresa.id == 0 || form.empresa.id == null)
            || (form.centroCusto.id == 0 || form.centroCusto.id == null);
    }

    handleSave(e, valueSaveAndGo) {
        e.preventDefault();
        this.state.form.assunto = "Campanha SMS";
        this.state.form.remetente = { id: 47 };
        this.state.form.tipoCampanha = SMS;
        let state = this.state;
        let form = this.state.form;
        let auth = this.state.auth;

        if (this.ValidarCampos(form)) {
            c.TOASTER_ERROR("Favor preencher os campos.");

        } else {

            let campanhaAdesaoPersonalizada = form.campanhaAdesaoPersonalizada
            let campoCampanhaAdesao = this.state.form.campoCampanhaAdesao.id == 0 ? this.state.campoCampanha.id : this.state.form.campoCampanhaAdesao.id;
            let nomeCampanhaAdesao = this.state.form.nomeCampanhaAdesao;
            let campoSelecionado = '';

            if (campanhaAdesaoPersonalizada) {
                if (campoCampanhaAdesao) {
                    campoSelecionado = this.state.comboCampoCampanhaAdesao.results.filter(item => {
                        return item.value == campoCampanhaAdesao;
                    });

                    form.campoCampanhaAdesao = { id: campoSelecionado[0].value };
                } else {
                    c.TOASTER_ERROR("Favor preencher os campos.");
                    return;
                }


                if (nomeCampanhaAdesao) {
                    form.nomeCampanhaAdesao = nomeCampanhaAdesao;
                    form.urlGeradoCampanhaAdesao = this.state.urlGeradoCampanhaAdesao;
                } else {
                    c.TOASTER_ERROR("Favor preencher os campos.");
                    return;
                }

                if (state.form.campanhaAdesao === '') {
                    this.state.form.campanhaAdesao = { id: 0 }
                }
            }

            form.adhesionCampaignFields = {
                campoCampanhaAdesaoId: form.campoCampanhaAdesao.id !== 0 ? form.campoCampanhaAdesao : null,
                nomeCampanhaAdesao: form.nomeCampanhaAdesao,
                urlGeradoCampanhaAdesao: form.urlGeradoCampanhaAdesao,
                campanhaAdesaoPersonalizada: form.campanhaAdesaoPersonalizada,
                campanhaAdesao: form.campanhaAdesao.id !== 0 ? form.campanhaAdesao : null              
            };

            form.emailUsuario = this.state.usuario.email;

            this.setState({ ...this.state, loading: true });
            if (state.novaCampanha) {

                this.props.actions.campanha.salvarPassoUm(form, auth).then((response) => {
                    this.setState({ ...this.state, loading: false });
                    getRetorno(response, this);
                }).catch((error) => {
                    this.setState({ ...this.state, loading: false });
                    if (error.message) c.TOASTER(error.type, error.message);
                    else c.TOASTER_ERROR(c.NETWORK_ERROR);
                });

            } else {

                let idCampanha = state.idCampanha;
                this.props.actions.campanha.editarPassoUm(form, auth, idCampanha).then((response) => {
                    this.setState({ ...this.state, loading: false });
                    getRetorno(response, this);
                }).catch((error) => {
                    this.setState({ ...this.state, loading: false });
                    if (error.message) c.TOASTER(error.type, error.message);
                    else c.TOASTER_ERROR(c.NETWORK_ERROR);
                });

            }


        }


        function getRetorno(response, value) {
            if (response.debugMessage) {
                c.TOASTER_ERROR(response.debugMessage);
            } else if (response.status === 500) {
                c.TOASTER_ERROR(c.DEFAULT_ERROR)
            } else if (response.status !== 500) {
                value.props.campanha.idCampanha = response.idCampanha;
                value.props.campanha.urlRetorno = c.CAMPAIGN_ROUTE + "/nova-sms/" + response.idCampanha;
                if (typeof valueSaveAndGo === "undefined") {
                    c.TOASTER_SUCCESS("Campanha salva com sucesso!");
                    value.props.history.push(c.PANEL_ROUTE);
                } else {
                    c.TOASTER_SUCCESS("Campanha salva com sucesso!");
                    value.props.history.push({pathname: c.CAMPAIGN_ROUTE + "/nova-sms/editor", state: { empresa: form.empresa }})
                }
            }
        }

    }

    async handleSaveAndGo(e) {
        this.handleSave(e, e.currentTarget.textContent);
    }

    render() {
        const form = this.state.form;

        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-5">
                    <Column size="9" className="mx-auto container">
                        {/* MAIN TITLE */}
                        <Row className="mb-3">
                            <Column size="6" className="pl-0">
                                <h2 className="fs-20 fw-600 text-body m-0">Nova campanha</h2>
                            </Column>
                            <Column size="6" className="pr-0">
                                <div className="input-group d-block fs-14 text-right">
                                    <button
                                        type="button"
                                        onClick={this.handleSave}
                                        className="btn btn-link px-3"
                                    >
                                        Salvar
                                    </button>
                                    <button
                                        type="button"
                                        onClick={this.handleSaveAndGo}
                                        className="btn btn-primary px-4"
                                    >
                                        Salvar e avançar <Icon name="fa-chevron-right" className="ml-2" />
                                    </button>
                                </div>
                                <div className="ml-4">
                                    {this.state.loading && (
                                        <CircularProgress
                                            size={20}
                                            thickness={4}
                                            color="inherit"
                                            variant="indeterminate"
                                        />
                                    )}
                                </div>
                            </Column>
                        </Row>
        
                        {/* FORM CAMPANHA - Início */}
                        <Row className="mb-0" style={{ borderTop: "none" }}>
                            <Column size="3" className="pt-3 pl-0">
                                <h3 className="fs-14 fw-600 text-body m-0 mb-3">Detalhes da campanha</h3>
                                <h5 className="fs-12 fw-400 text-muted">
                                    Informações para organizar a campanha dentro da plataforma.
                                </h5>
                            </Column>
                            <Column size="2"></Column>
                            <Column size="7" className="pt-0 pr-0">
                                <IBox className="mb-0" style={{ borderTop: "solid 4px #e7eaec" }}>
                                    <Content className="border-0 p-4 container">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="nome"
                                                value={form.nome}
                                                onChange={this.handleChange}
                                                placeholder="Nome da campanha"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group mb-0">
                                            <Select
                                                name="empresa"
                                                selected={form.empresa.id}
                                                data={this.state.comboEmpresa}
                                                onChange={this.handleChange}
                                                placeholder="Empresa"
                                            />
                                        </div>
                                        <div className="form-group mb-0">
                                            <SelectCentroCusto
                                                name="centroCusto"
                                                selected={form.centroCusto.id}
                                                data={this.state.comboCentroCusto}
                                                onChange={this.handleChange}
                                                placeholder="Centro de Custo"
                                            />
                                        </div>
                                    </Content>
                                </IBox>
                            </Column>
                        </Row>
        
                        {/* FORM LISTA - Início */}
                        <Row className="mb-4" style={{ borderTop: "solid 1px #e9e9e9" }}>
                            <Column size="3" className="pt-3 pl-0">
                                <h3 className="fs-14 fw-600 text-body m-0 mb-3">Destinatário</h3>
                                <h5 className="fs-12 fw-400 text-muted">
                                    Selecione para qual lista de contatos gostaria de enviar a sua campanha.
                                </h5>
                            </Column>
                            <Column size="2"></Column>
                            <Column size="7" className="pt-0 pr-0">
                                <IBox className="mb-0">
                                    <Content className="border-0 p-4 container">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="procurar"
                                                onChange={this.handleSearch}
                                                placeholder="Procurar..."
                                                className="form-control"
                                            />
                                        </div>
                                        <div
                                            className="form-group mb-0 table-responsive"
                                            style={{ maxHeight: "212px" }}
                                        >
                                            <Table
                                                name="contatoId"
                                                selected={form.listaContato.id}
                                                data={this.state.list}
                                                history={this.props.history}
                                                onChange={this.handleCheckChange}
                                            />
                                        </div>
                                    </Content>
                                </IBox>
                            </Column>
                        </Row>
        
                        {/* FORM - Campanha de adesao */}
                        <Row className="mb-0" style={{ borderTop: "solid 1px #e9e9e9" }}>
                            <Column size="3" className="pt-3 pl-0">
                                <h3 className="fs-14 fw-600 text-body m-0 mb-3">Campanha de Adesão</h3>
                                <h5 className="fs-12 fw-400 text-muted">
                                    Configure a campanha de adesão e gere o link para utilizá-lo em seus templates.
                                </h5>
                            </Column>
                            <Column size="2"></Column>
                            <Column size="7" className="pt-0 pr-0">
                                <IBox className="mb-0">
                                    <Content className="border-0 p-4 container">
                                    <div className="form-group float-left d-inline" style={{ height: "32.8px", lineHeight: "32.8px" }}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={form.campanhaAdesaoPersonalizada}
                                                        onChange={this.handleChange}
                                                        color="primary"
                                                        name="campanhaAdesao"
                                                    />
                                                }
                                                label="Campanha de Adesão?"
                                            />
                                        </div>
                                        <div className="form-group float-right d-inline" style={{ maxWidth: "200px" }}>
                                            <Select
                                                name="campoCampanhaAdesao"
                                                selected={form.campoCampanhaAdesao.id}
                                                data={this.state.comboCampoCampanhaAdesao}
                                                onChange={this.handleChange}
                                                placeholder="Campo"
                                                disabled={this.state.disabledSelectCampanhaAdesao}
                                                isTag={false}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="nomeCampanhaAdesao"
                                                value={form.nomeCampanhaAdesao}
                                                onChange={this.handleChange}
                                                onBlur={this.handleBlur}
                                                placeholder="Nome Campanha de Adesão"
                                                className="form-control"
                                                disabled={this.state.disabledNomeCampanhaAdesao}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="urlGeradoCampanhaAdesao"
                                                value={this.state.urlGeradoCampanhaAdesao}
                                                onChange={this.handleChange}
                                                placeholder="Link para Campanha de Adesão"
                                                className="form-control"
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="form-group container">
                                            <div className="row">
                                                <div className="col-1 m-0 px-1">
                                                    <img src="assets/images/info.svg" className="text-info" />
                                                </div>
                                                <div className="col-11 m-0 px-0">
                                                    O link, que será gerado após preenchimento do nome da campanha de adesão, deverá ser copiado para ser utilizado posteriormente no template da campanha!
                                                </div>
                                            </div>
                                        </div>
                                    </Content>
                                </IBox>
                            </Column>
                        </Row>
        
                        {/* SAVE */}
                        <Row className="mb-0">
                            <Column size="5" className="pl-0"></Column>
                            <Column size="7" className="pr-0 clearfix">
                                <div className="input-group d-block text-right">
                                    <button
                                        type="button"
                                        onClick={this.handleSave}
                                        className="btn btn-link px-3"
                                    >
                                        Salvar
                                    </button>
                                    <button
                                        type="button"
                                        onClick={this.handleSaveAndGo}
                                        className="btn btn-primary px-4"
                                    >
                                        Salvar e avançar <Icon name="fa-chevron-right" className="ml-2" />
                                    </button>
                                </div>
                                <div className="ml-4">
                                    {this.state.loading && (
                                        <CircularProgress
                                            size={30}
                                            thickness={4}
                                            color="inherit"
                                            variant="indeterminate"
                                        />
                                    )}
                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }

    SelecionarTipoOperacao() {
        let self = this;
        let idCampanha = self.state.locationUrl.split("/")[3];

        self.state.idCampanha = idCampanha
        self.state.novaCampanha = idCampanha ? false : true;

    }

    RecuperarIdCampanhaEditar() {
        let self = this;
        let idCampanha = self.state.idCampanha;
        let editarCampanha = !self.state.novaCampanha;

        if (editarCampanha) {

            const url = `${c.API_CAMPAIGN_URL}/public/campaign/id/${idCampanha}`;
            const options = self.state.optionsGet;

            self.setState({ ...self.state, loading: true })

            callApi(url, options, function (response) {
                self.setState({ ...self.state, comboCentroCusto: response.listaCentroCusto });

                const adesao = response.adhesionCampaignFields || response;

                const campanhaAdesaoPersonalizada = !!adesao.campanhaAdesaoPersonalizada;

                const campoCampanhaAdesao = adesao.campoCampanhaAdesaoId
                    ? { id: adesao.campoCampanhaAdesaoId.id }
                    : { id: 0 };

                const nomeCampanhaAdesao = adesao.nomeCampanhaAdesao || '';

                const urlGeradoCampanhaAdesao = adesao.urlGeradoCampanhaAdesao || '';

                const campanhaAdesao = adesao.campanhaAdesao && adesao.campanhaAdesao.id
                    ? { id: adesao.campanhaAdesao.id }
                    : { id: 0 };



                self.setState({
                    ...self.state, loading: false, form: {
                        nome: response.nome,
                        empresa: response.empresa,
                        emailUsuario: response.emailUsuario,
                        centroCusto: response.centroCusto,
                        listaContato: response.listaContato,
                        campanhaAdesaoPersonalizada: campanhaAdesaoPersonalizada,
                        campoCampanhaAdesao: campoCampanhaAdesao,
                        nomeCampanhaAdesao: nomeCampanhaAdesao,
                        urlGeradoCampanhaAdesao: urlGeradoCampanhaAdesao,
                        campanhaAdesao: campanhaAdesao
                    },
                    urlGeradoCampanhaAdesao: urlGeradoCampanhaAdesao
                });

                self.setState({
                    ...self.state,
                    disabledSelectCampanhaAdesao: !campanhaAdesaoPersonalizada,
                    disabledNomeCampanhaAdesao: !campanhaAdesaoPersonalizada
                });
                self.LoadComboTagPorLista(self.state.form.listaContato.id, true);
            });

        }
    }

    LoadComboCentroCusto(idEmpresa) {
        let self = this;

        const url = `${c.API_BASE_URL}/centroCusto-empresa/${idEmpresa}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboCentroCusto: response });
        });
    }

    LoadComboEmpresa() {
        let self = this;
        const url = `${c.API_BASE_URL}/company-user`;

        const data = JSON.stringify({
            'id_produto': SMS
        });
        const options = {
            method: 'POST',
            body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    LoadListaContato() {
        let self = this;
        let page = 0;
        let limit = 200;
        let idCampanhaArg = 0;
        let telaCampanha = true;
        let tipoLista = SMS;

        if (this.state.idCampanha != '' && this.state.idCampanha != undefined && this.state.idCampanha > 0) {
            idCampanhaArg = this.state.idCampanha;
        }

        const url = `${c.API_BASE_URL}/listContactEditCampanha/${limit}/${page}/${telaCampanha}/${idCampanhaArg}/${tipoLista}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, list: response, filteredList: response });
        });
    }

    LoadComboCampoCampanhaAdesao(selectedId) {

        if (!selectedId || selectedId === 0) return;

        let self = this;
        const url = `${c.API_BASE_URL}/campanha/adesao/campo/combo/${selectedId}`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, comboCampoCampanhaAdesao: response });
        });
    }


}

class Table extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 0
        }

    }

    static defaultProps = {
        name: "",
        selected: 0,

    };

    statusEnvio(status) {
        if (status == "Em Uso") {
            return (
                < span style={
                    { color: "#BBBBBB" }
                } > Em Uso
                </span>
            )
        }
        else if (status == "Utilizada") {
            return (< span style={
                { color: "#BBBBBB" }
            } > Utilizada </span>)
        }
        else if (status == "Ativa") {
            return (
                < span style={
                    { color: "#01BC8E" }
                } > Ativa
                </span>
            )
        }
    }

    render() {
        const data = this.props.data;
        let html = "";

        if (data.results === undefined) {
            html = (<tr> <td colSpan="4" scope="row" > Carregando... </td></tr>)

        } else if (data.results.length === 0) {
            html = (<tr> <td colSpan="4" scope="row" > Nenhum registro encontrado. </td></tr>)

        } else if (data.results.length > 0) {

            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td style={{ verticalAlign: "middle" }}>
                        <div className="radio" style={{ height: "13px" }}>
                        <input type="radio" name={this.props.name} value={row.id} checked={row.id === parseInt(this.props.selected)} onChange={(e) => {
                                    this.props.onChange(e);
                                }} />
                        </div>{" "}
                    </td>{" "}
                    <td> {row.nome} </td> <td> {row.contatos} </td> <td> {this.statusEnvio(row.status)} </td>{" "}
                </tr>

            )
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th> </th> <th> Nome da lista </th> <th> Contatos </th> <th> Status </th>{" "}
                    </tr>{" "}
                </thead>
                <tbody> {html} </tbody>{" "}
            </table>
        )
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, campanha: state.campanha };
}

function mapDispatchToProps(dispatch) {
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NovaSms));